/** @jsx jsx */
import { jsx } from '@theme-ui/core';

type ErrorMessageProps = {
    children: React.ReactNode;
};

export const ErrorMessage = ({ children }: ErrorMessageProps) => {
    return (
        <div
            sx={{
                variant: 'text.body',
                marginTop: 1,
                color: 'whitelabel.failure',
            }}
        >
            {children}
        </div>
    );
};
